module.exports = "/_next/static/images/85919cdd0ec7f15a9b356db0de0baa49-rewards-app-lg@3x.png.webp";